// src/Components/Footer/Contact.js
import React from "react";

const Contact = () => {
  return (
    <section className=" py-5 px-3" id="contact">
      <div className="container">
        <div className="row align-items-center">
          {/* Contact Info */}
          <div className="col-md-6 mb-4">
            <h2 className="mb-3 fw-bold text-success">Let's Connect</h2>
            <p className="mb-4 text-muted">
              Got questions about our fresh picks or delivery? We're just a
              message away.
            </p>
            <ul className="list-unstyled">
              <li className="mb-2">
                <strong>
                  <i className="bi bi-envelope-fill me-2"></i>
                </strong>{" "}
                <a href="mailto:support@naturalsupermart.com" className="text-decoration-none text-dark">
                  uzhavan@gmail.com
                </a>
              </li>
              <li className="mb-2">
                <strong>
                  <i class="bi bi-telephone"></i>
                </strong>{" "}
                <a href="tel:+919876543210" className="text-decoration-none text-dark">+91 7904235014</a>
              </li>
              <li className="mb-2">
                <strong>
                  <i class="bi bi-geo-alt-fill"></i>
                </strong>{" "}
                No.99/23B1, Vellore Main Road, <br/>
                Anna Nagar Street-1, Arcot <br/>
                Ranipet, Tamilnadu - 632503<br/>
              </li>
            </ul>
            <p className="mt-4 text-muted small fst-italic">
              We typically respond within 24 hours. Let’s grow something healthy
              together 🌿
            </p>
          </div>

          {/* Contact Form */}
          <div className="col-md-6">
            <div className=" shadow p-2 rounded">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.060083218299!2d79.3122872!3d12.9038581!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bad35002ee58ca3%3A0x6818509eea2c4518!2sUzhavan%20Supermarket!5e0!3m2!1sen!2sin!4v1754369550725!5m2!1sen!2sin"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Uzhavan Supermarket Location"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
